"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.correctionReportQuerySchema = exports.correctionReportParameterFilterEnum = exports.correctionReportStageFilterEnum = void 0;
/**
 * Request contract for the MAIN COUNTER's CORRECTIONS REPORT (desk, 2026-10-12):
 *
 *   "Need dedicated Corrections under reports page in main counter module ... this register or report should show Correction
 *    request with full detailed report. Only have access to main counter."
 *
 * It is the hospital-wide view — every correction request, whoever entered it — so it is NOT the clerk's own register
 * (`correctionRegisterQuerySchema`, Cash Counter -> Correction). Who may read it is decided on the route, by the same
 * permission that opens the Main Counter module (`cash-management:summary:read`).
 *
 * The two enums below repeat the values of `correctionStageEnum` / `correctionRegisterParameterEnum` on purpose: this file sits
 * on the request side and the response files import FROM it, never the other way round. A test pins that they stay equal.
 */
const zod_1 = require("zod");
/** `''` from an empty form box means "no filter", never "match nothing". */
const blankIsUndefined = (value) => (typeof value === 'string' && value.trim() === '' ? undefined : value);
const optionalText = (max) => zod_1.z.preprocess(blankIsUndefined, zod_1.z.string().trim().max(max).optional());
const calendarDay = zod_1.z.preprocess(blankIsUndefined, zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Use a date as YYYY-MM-DD').optional());
exports.correctionReportStageFilterEnum = zod_1.z.enum(['AWAITING_VERIFICATION', 'AWAITING_APPROVAL', 'APPROVED', 'REJECTED']);
exports.correctionReportParameterFilterEnum = zod_1.z.enum(['PAYMENT_METHOD', 'OP_NUMBER', 'DOCTOR_TRANSFER', 'BILL_NUMBER', 'PATIENT_NAME', 'ADVANCE_AMOUNT', 'CANCEL_RECEIPT']);
exports.correctionReportQuerySchema = zod_1.z.object({
    /** First and last day the request was ENTERED (inclusive, hospital local day). */
    fromDate: calendarDay,
    toDate: calendarDay,
    /** Part of the receipt number printed on the receipt. */
    receiptNumber: optionalText(50),
    /** Part of an OP number (UHID) — either end of an OP-number move. */
    opNumber: optionalText(30),
    /** The user who ENTERED the request. */
    requestedBy: zod_1.z.preprocess(blankIsUndefined, zod_1.z.string().uuid().optional()),
    /** What was asked to be corrected. */
    parameter: zod_1.z.preprocess(blankIsUndefined, exports.correctionReportParameterFilterEnum.optional()),
    /** Where the request stands now. */
    stage: zod_1.z.preprocess(blankIsUndefined, exports.correctionReportStageFilterEnum.optional()),
    limit: zod_1.z.coerce.number().int().positive().max(1000).default(300),
});
//# sourceMappingURL=financial-correction-report.request.js.map